<template>
	<div class="">
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="row py-5 pt-container">
			<div class="col-md-6">
				<div class="wid-fit d-flex flex-column align-items-center">
					<div class="ftr-1-5 ftw600 personalizationTeacher-photo">
						<!-- 尋找你的個性化導師 -->
						{{$t('personalizationTeacher.seacherTeacher')}}
					</div>
					<img src="../../assets/image/index/index-ph1.png" alt="" class="personalizationTeacher-photo mt-4" />
				</div>
			</div>
			<div class="col-md flex flex-column justify-content-end alcenter pt-mt-2 mt-sm-2">
				<div class="">
					<!-- 花1分鐘回答幾條簡單問题， -->
					{{$t('personalizationTeacher.hint')}}
				</div>
				<div class="mt-4 cl-info ft16">
					<!-- 你学习的目的是？ -->
					{{$t('personalizationTeacher.studyFor')}}
				</div>
				<select class="form-select mt-2 personalizationTeacher-photo">
					<option selected>補智舆公開試</option>
				</select>
				<button type="button" class="btn btn-dark bg-theme ftw600 mt-5 py-2 cl-black personalizationTeacher-photo"
				 @click="toStudy">
					<!-- 開始 -->
					{{$t('personalizationTeacher.start')}}
				</button>
				<div class="flex mt-3 text-underline clickAct flex justify-content-center cl-info personalizationTeacher-photo">
					<!-- 自行挑選導師 -->
					{{$t('personalizationTeacher.selectTeacher')}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		methods:{
			toStudy(){
				this.$router.push('/forStudy');
			},
		}
	}
</script>

<style scoped>
	
	.personalizationTeacher-photo{
		width: 60%;
	}
	@media (max-width:575.98px) {
		.personalizationTeacher-photo{
			width: 100%;
		}
		.p-6 {
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}
		.pt-mt-2{
			margin-top: 1rem;
		}
		.pt-container {
			margin: auto;
			width: 95%;
		}
	}
	@media (min-width: 576px) {
		.pt-container {
			margin: auto;
			width: 580px;
			margin-top: 8%;
		}
	
	}
	
	@media (min-width: 768px) {
		.pt-container {
			margin: auto;
			width: 900px;
			margin-top: 8%;
		}
	}
	
	@media (min-width: 1200px) {
		.pt-container {
			margin: auto;
			width: 1100px;
			margin-top: 8%;
		}
	}
	
	@media (min-width: 1400px) {
		.pt-container {
			margin: auto;
			width: 1300px;
			margin-top: 8%;
		}
	}
</style>